module.exports = __webpack_public_path__ + "static/media/space.60fc8784.png";